/*React-component */
import ProgramStructureContainerTreeItem from "./ProgramStructureContainerTreeItem";

/* React-Bootstrap component */
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

const ProgramStructureContainerTree = ({
  program,
  changeProgramStatus,
  searchQuery,
}) => {
  if (Object.keys(program).length === 0) {
    return null;
  } else {
    return (
      <>
        {program.children?.map((k2) => {
          return (
            <Row key={k2.objectID}>
              <Col>
                <Card className="mb-2 programs-margin-left">
                  <Card.Body className="pb-0 pt-0">
                    <Row>
                      <Col>
                        <ProgramStructureContainerTreeItem
                          program={k2}
                          changeProgramStatus={changeProgramStatus}
                          searchQuery={searchQuery}
                        />
                      </Col>
                    </Row>

                    <>
                      {k2.children?.map((k3) => {
                        return (
                          <Row key={k3.objectID}>
                            <Col>
                              <Card className="mb-2 border-left-card-n3 programs-margin-left">
                                <Card.Body className="pb-0 pt-0">
                                  <ProgramStructureContainerTreeItem
                                    program={k3}
                                    changeProgramStatus={changeProgramStatus}
                                    searchQuery={searchQuery}
                                  />

                                  <>
                                    {k3.children?.map((k4) => {
                                      return (
                                        <Row key={k4.objectID}>
                                          <Col>
                                            <Card className="mb-2 border-left-card-n4 programs-margin-left ">
                                              <Card.Body className="pb-0 pt-0">
                                                <ProgramStructureContainerTreeItem
                                                  program={k4}
                                                  nivoK4={"true"}
                                                  changeProgramStatus={
                                                    changeProgramStatus
                                                  }
                                                  searchQuery={searchQuery}
                                                />
                                              </Card.Body>
                                            </Card>
                                          </Col>
                                        </Row>
                                      );
                                    })}
                                  </>
                                </Card.Body>
                              </Card>
                            </Col>
                          </Row>
                        );
                      })}
                    </>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          );
        })}
      </>
    );
  }
};

export default ProgramStructureContainerTree;
